import React from "react"
import { ELoggedInUserType, IObjectTimecardDocument, IPayrollStatusDocument, ITimecardEmployee, IDate, IPayrollPayGroupData } from "../../models"
import TimecardWeekTable from "./TimecardWeekTable"
import strings from "../../localization/strings"
import * as colorHelper from "../../helpers/colorHelper"
import { FlatButton } from "material-ui"
import moment from "moment"
import ExternalLink from "../common/externalLink/ExternalLink"
import ExportDiffTimecardDialog from "../prior_period/ExportDiffTimecardDialog"
import * as payGroupAndTypeHelper from "../../helpers/payGroupAndTypeHelper"
import * as timecardHelper from "../../helpers/timecardHelper"
import AppStateStore from "../../stores/AppStateStore"
interface IProps {
    timecardReferenceDate: IDate
    payrollPayGroupData: IPayrollPayGroupData
    priorPeriodTimecards: IObjectTimecardDocument[]
    lockData: IPayrollStatusDocument[]
    loggedInUserType: ELoggedInUserType
    userId: string
    reloadTimecards(msg: string): void
}
interface IState {
    openExportDiffTimecardId: string
}

export default class TimecardPriorPeriodAdjustments extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openExportDiffTimecardId: null
        }
    }

    render() {
        return (
            <div>
                {this.props.priorPeriodTimecards
                    .sort((a, b) => (a.PriorPeriodData.DifferenceTimecard && !b.PriorPeriodData.DifferenceTimecard) ? -1 : 1)
                    .map((timecard, ppIndex) => {
                        const originalTimecard = timecard.PriorPeriodData ? (timecard.PriorPeriodData.DifferenceTimecard ? false : true) : false
                        const diffTimecard = timecard.PriorPeriodData ? (timecard.PriorPeriodData.DifferenceTimecard ? true : false) : false
                        let timecardLabel = originalTimecard ? strings.Original_Timecard : diffTimecard ? strings.Pending_Difference_Timecard : strings.Modified_Timecard
                        if (timecard.PriorPeriodData && timecard.PriorPeriodData.DifferenceExported) {
                            timecardLabel = strings.Exported_Difference_Timecard
                        }
                        const colorByPayPeriod = colorHelper.getTimecardPrimaryColor(timecard.PriorPeriodData)
                        return (
                            <div key={ppIndex}>
                                {timecard.MasterTimecard.TimecardWeeks.map((timecardWeek, i) =>
                                    <div key={i + "_" + ppIndex}>
                                        <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", height: diffTimecard ? 45 : 20, color: colorByPayPeriod }}>
                                            <b>{timecardLabel.toUpperCase()}</b>
                                            {diffTimecard &&
                                                <div style={{ display: "flex" }}>
                                                    <FlatButton
                                                        data-intercom-target={"Difftimecard-Btn-ExportDialog"}
                                                        label={timecard.PriorPeriodData.DifferenceExported ? strings.ReExport : strings.Export}
                                                        backgroundColor={colorHelper.getTimecardPrimaryColor(timecard.PriorPeriodData)}
                                                        hoverColor={colorHelper.getTimecardPrimaryColorHover(timecard.PriorPeriodData)}
                                                        style={{ color: "white" }}
                                                        onClick={() => {
                                                            timecardHelper.timecardHasExpenses(timecard) ?
                                                            this.setState({ openExportDiffTimecardId: timecard.Id }) :
                                                            AppStateStore.setAlertDialogContent({
                                                                content: strings.Cannot_export_because_there_is_no_any_difference
                                                            })
                                                        }}
                                                    />
                                                    {timecard.PriorPeriodData.DifferenceExported &&
                                                        <div style={{ fontSize: 14, marginLeft: 10 }}>
                                                            <b><ExternalLink url={`/user-details/${timecard.ObjectId}/timecards?referenceDate=${moment(timecard.PriorPeriodData.DestinationTimecardStartDate).utc().format("MM/DD/YY")}`} fontSize={"14"} iconColor={colorHelper.getTimecardPrimaryColor(timecard.PriorPeriodData)} /> Destination Timecard {moment(timecard.PriorPeriodData.DestinationTimecardStartDate).utc().format("MM/DD/YY")}</b>
                                                            <div><i>Exported {moment(timecard.PriorPeriodData.ExportedDateTime).format("MM/DD/YY h:mma")} by {timecard.PriorPeriodData.ExportedUserName}</i></div>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                        <TimecardWeekTable
                                            priorPeriodAdjustMode
                                            originalTimecard={originalTimecard}
                                            dailyNoteDates={[]} //this.state.dailyNoteDates}
                                            timecard={timecard}
                                            timecardWeek={timecardWeek}
                                            lockData={this.props.lockData}
                                            employee={timecard.Employee as ITimecardEmployee}
                                            onAddPunchToTimecardDay={null} //this.addPunchToTimecardDay}
                                            onTimeChange={null} //this.onTimeChange}
                                            onConfirmDelete={null} //this.onConfirmDelete}
                                            readonly
                                            hierarchyItemId={timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1 ?
                                                timecard.ComponentTimecards[0].HierarchyItem ?
                                                    timecard.ComponentTimecards[0].HierarchyItem.Id :
                                                    null :
                                                timecard.Employee.DefaultPunchHierarchyId
                                            }
                                            jobId={timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1 ?
                                                timecard.ComponentTimecards[0].JobId :
                                                timecard.Employee.DefaultJobId
                                            }
                                            phaseId={timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1 ?
                                                timecard.ComponentTimecards[0].PhaseId :
                                                timecard.Employee.DefaultPhaseId
                                            }
                                            positionId={
                                                timecard.ComponentTimecards && timecard.ComponentTimecards.length === 1 ?
                                                    timecard.ComponentTimecards[0].Position ?
                                                        timecard.ComponentTimecards[0].Position.Id :
                                                        null :
                                                    timecard.Employee.DefaultPositionId
                                            }
                                            payrollHierarchyId={timecard.PayrollHierarchyId}
                                            payrollPayGroupId={timecard.PayrollPayGroupId}
                                            openDailyHistoryDrawer={null} //this.openDailyHistoryDrawer}
                                            reloadTimecard={this.props.reloadTimecards} //this.loadTimecardsAfterUpdatePunch}
                                            handleApproveStatus={null} //this.handleApproveStatus}
                                            loggedInUserType={this.props.loggedInUserType}
                                            isFullTimecard
                                            showExpenseRow
                                            showTimecardDetails={true}
                                            payrollDataForPayGroup={this.props.payrollPayGroupData}
                                        />
                                    </div>
                                )}
                            </div>
                        )
                    })}
                {this.state.openExportDiffTimecardId &&
                    <ExportDiffTimecardDialog
                        timecardReferenceDate={this.props.timecardReferenceDate}
                        payGroupId={payGroupAndTypeHelper.getPayGroupIdByPayrollPayGroupData(this.props.payrollPayGroupData)}
                        userId={this.props.userId}
                        timecardId={this.state.openExportDiffTimecardId}
                        handleClose={() => this.setState({ openExportDiffTimecardId: null })}
                        reloadTimecards={this.props.reloadTimecards}
                    />
                }
            </div>
        )
    }
}